const s={primary:"primary",secondary:"secondary"};var n=(t=>(t.LinkButton="LinkButton",t.Button="Button",t))(n||{});export{n as ActionTypes,s as backgrounds};
//# sourceMappingURL=modal.types.js.map
